import React, { Component } from 'react';
import '../../inc/genstyle.css';
import RandomNumber from '../../inc/random-number';
import { FormErrors } from '../../inc/error-form';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[48];

class BudgetProjectForm extends Component {
    constructor (props) {
        super(props);
        this.state = {
            stPopTitle: '',
            type: '',
            budgetdoc_id: '',
            projectdoc_id: '',
            project_id_gcp: '',
            project_number_gcp: '',
            project_name_gcp: '',
            billing_account_id: '',
            approved_by: '',
            refer_to: '',
            company_domain: '',
            company_name: '',
            cuan_company: {},
            cuan_subcompany: {},
            formErrors: {project_id_gcp: '', project_number_gcp: '', project_name_gcp: '', billing_account_id: '', approved_by: ''},
            projectidgcpValid: false,
            projectnumbergcpValid: false,
            projectnamegcpValid: false,
            billingaccountidValid: false,
            approvedbyValid: false

        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleSelect = (e) => {
        const value = e.target.value;
        const inputname = e.target.name;
        this.setState( prevState => {
            return {  
                ...prevState[inputname], [inputname]: value
            }
            },() => { this.validateField(inputname, value)}
        )
      }
    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value},
            () => { this.validateField(name, value)});
    }
    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let projectidgcpValid = this.state.projectidgcpValid;
        let projectnumbergcpValid = this.state.projectnumbergcpValid;
        let projectnamegcpValid = this.state.projectnamegcpValid;
        let billingaccountidValid = this.state.billingaccountidValid;
        let approvedbyValid = this.state.approvedbyValid;
        

        switch(fieldName) {
            case 'project_id_gcp': 
                projectidgcpValid = value.trim().length > 0;
                fieldValidationErrors.project_id_gcp = projectidgcpValid ? '' : 'project id need to be filled';
                break;
            case 'project_number_gcp': 
                projectnumbergcpValid = value.trim().length > 0;
                fieldValidationErrors.project_number_gcp = projectnumbergcpValid ? '' : 'project number need to be filled';
                break;
            case 'project_name_gcp': 
                projectnamegcpValid = value.trim().length > 0;
                fieldValidationErrors.project_name_gcp = projectnamegcpValid ? '' : 'project name need to be filled';
                break;
            case 'billing_account_id': 
                billingaccountidValid = value.trim().length > 0;
                fieldValidationErrors.billing_account_id = billingaccountidValid ? '' : 'billing account id need to be filled';
                break;
            case 'approved_by': 
                approvedbyValid = value.trim().length > 0;
                fieldValidationErrors.approved_by = approvedbyValid ? '' : 'approved by need to be filled';
                break;
            default:
                break;
        }
        //alert(fieldName + ':' + JSON.stringify(fieldValidationErrors));
        
        this.setState({formErrors: fieldValidationErrors,
                        projectidgcpValid: projectidgcpValid,
                        projectnumbergcpValid: projectnumbergcpValid,
                        projectnamegcpValid: projectnamegcpValid,
                        billingaccountidValid: billingaccountidValid,
                        approvedbyValid: approvedbyValid
                    }, this.validateForm);
      }
      validateForm() {
        // this.setState({formValid: this.state.licencetypeValid && this.state.licenceamountseatValid && this.state.licencepriceValid && this.state.licencestartdateValid && this.state.licenceperiodenumValid && this.state.licencepriceseatValid && this.state.licenceperiodenumbillcycleValid && this.state.licenceperiodeunitbillcycleValid });
        this.setState({formValid: this.state.projectidgcpValid && this.state.projectnumbergcpValid  && this.state.projectnamegcpValid && this.state.billingaccountidValid && this.state.approvedbyValid });
      }
    
      errorClass(error) {
        return(error.length === 0 ? '' : 'has-error');
      }

      handleSubmit(e) {
        e.preventDefault();
        if(this.state.project_id_gcp !== '' && this.state.project_number_gcp !== '' && this.state.project_name_gcp !== null) {
            document.getElementById('loading-area').style.display = 'block'; 
            var projectid_gcp,projectnumber_gcp,projectname_gcp,billingaccount_id,approved_by;
            if(this.textInputProjectIdGcp.value === '') { projectid_gcp = this.state.project_id_gcp; } else { projectid_gcp = this.textInputProjectIdGcp.value; }
            if(this.textInputProjectNumber.value === '') { projectnumber_gcp = this.state.project_number_gcp; } else { projectnumber_gcp = this.textInputProjectNumber.value; }
            if(this.textInputProjectNameGcp.value === '') { projectname_gcp = this.state.project_name_gcp; } else { projectname_gcp = this.textInputProjectNameGcp.value; }
            if(this.textInputBillingAccountId.value === '') { billingaccount_id = this.state.billing_account_id; } else { billingaccount_id = this.textInputBillingAccountId.value; }
            if(this.textInputApprovedBy.value === '') { approved_by = this.state.approved_by; } else { approved_by = this.textInputApprovedBy.value; }
            
            var data = {
                projectid_gcp: projectid_gcp,
                projectnumber_gcp: projectnumber_gcp,
                projectname_gcp: projectname_gcp,
                billingaccount_id: billingaccount_id,
                company_domain: this.state.company_domain,
                company_name: this.state.company_name,
                cuan_company_domain: this.state.cuan_company.companydomain,
                cuan_company_id: this.state.cuan_company.companyid,
                cuan_company_name: this.state.cuan_company.companyname,
                cuan_subcompany_id: this.state.cuan_subcompany.subcompanyid,
                cuan_subcompany_name: this.state.cuan_subcompany.subcompanyname,
                approved_by: this.state.approved_by
            }

            var urlFetch;
            if(this.state.type === "edit" && this.state.projectdoc_id !== "") {
                data.budget_docid = this.state.budgetdoc_id;
                data.project_docid = this.state.projectdoc_id;
                data.form_id = "form-editproject";
                urlFetch = global.config.urlLink+"/gcpbudgetprojectedit";
            } else {
                data.project_keyid = RandomNumber(10001,99999);
                data.budget_docid = this.state.budgetdoc_id;
                data.form_id = "form-addproject";
                urlFetch = global.config.urlLink+"/gcpbudgetprojectadd";
            }
            fetch(urlFetch, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': authKey,
                }, body : JSON.stringify(data)
              }).then(res => {
                if(res.status === 200) 
                    return res.json() 
              }).then( resJson => {
                document.getElementById('loading-area').style.display = 'none'; 
                if(resJson.status === '200') {
                    window.location.href='/'+this.state.activelink+'/'+this.state.budgetdoc_id;
                } else {
                    console.log('Something happened wrong');
                }
              }).catch(err => { 
                document.getElementById('loading-area').style.display = 'none'; 
                console.log(err);
              });

        } else {
            var arrfieldName = ['project_id_gcp','project_number_gcp','project_name_gcp','approved_by'];
            var arrvalue = [this.textInputProjectIdGcp.value,this.textInputProjectNumber.value,this.textInputProjectNameGcp.value,this.textInputApprovedBy.value];
            for(var ck in arrfieldName) {
                this.validateField(arrfieldName[ck], arrvalue[ck]);
            }
        }
      }

    componentDidMount() {
        document.getElementById('loading-area').style.display = 'block'; 
        var contents = JSON.parse(document.getElementById("contentoth").innerText);
        // var othersContent = contents.dataSend;
       
        this.setState({
            activelink: contents.activelink,
            type: contents.type,
            refer_to: contents.refer_to,
            budgetdoc_id: contents.budget_docid,
            projectdoc_id: contents.project_docid,
            project_id_gcp: contents.project_id_gcp,
            project_number_gcp: contents.project_number_gcp,
            project_name_gcp: contents.project_name_gcp,
            billing_account_id: contents.billing_account_id,
            company_domain: contents.company_domain,
            company_name: contents.company_name,
            cuan_company: contents.cuan_company,
            cuan_subcompany: contents.cuan_subcompany,
            approved_by: contents.approved_by
        })
        document.getElementById('loading-area').style.display = 'none'; 
    
    }
    render() {
        
        return (
            <div className="main-container">
                <div className="mgT30">
                    <form onSubmit={this.handleSubmit}>

                        
                        <div className="row-field mgT20">
                            <label className="labelFormL" htmlFor="project_id_gcp">Project ID</label>
                            <div className="w70p">
                                <input type="text" className="form-control" name="project_id_gcp"
                                    placeholder={this.state.project_id_gcp}
                                    value={this.state.project_id_gcp}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputProjectIdGcp = input}/>
                                <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.project_id_gcp}/>  }</div>
                            </div>
                        </div>
                        <div className="row-field mgT20">
                            <label className="labelFormL" htmlFor="project_number_gcp">Project Number</label>
                            <div className="w70p">
                                <input type="text" className="form-control" name="project_number_gcp"
                                    placeholder={this.state.project_number_gcp}
                                    value={this.state.project_number_gcp}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputProjectNumber = input}/>
                                <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.project_number_gcp}/>  }</div>
                            </div>
                        </div>
                        <div className="row-field mgT20">
                            <label className="labelFormL" htmlFor="project_name_gcp">Project Name</label>
                            <div className="w70p">
                                <input type="text" className="form-control" name="project_name_gcp"
                                    placeholder={this.state.project_name_gcp}
                                    value={this.state.project_name_gcp}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputProjectNameGcp = input}/>
                                <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.project_name_gcp}/>  }</div>
                            </div>
                        </div>
                        <div className="row-field mgT20">
                            <label className="labelFormL" htmlFor="billing_account_id">Billing Account ID</label>
                            <div className="w70p">
                                <input type="text" className="form-control" name="billing_account_id"
                                    placeholder={this.state.billing_account_id}
                                    value={this.state.billing_account_id}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputBillingAccountId = input}/>
                                <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.billing_account_id}/>  }</div>
                            </div>
                        </div>
                        <div className="row-field mgT20">
                            <label className="labelFormL" htmlFor="approved_by">Approved By</label>
                            <div className="w70p">
                                <select name="approved_by" className="form-control" 
                                    value={this.state.approved_by} 
                                    onChange={this.handleSelect}
                                    ref={(input) => this.textInputApprovedBy = input}
                                >
                                    <option value="">--- please select ----</option>
                                    <option value="GIR">GIR</option>
                                    <option value="Internal">Internal</option>
                                    <option value="Clients">Clients</option>
                                    <option value="Others">Others</option>
                                </select>
                                <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.approved_by}/>  }</div>
                            </div>
                        </div>

                        <div className="row-field mgT30 mgB30">
                            <input type="hidden" required name="projectdoc_id" value={this.state.projectdoc_id} />
                            <button type="submit" className="w100p submitButton">Submit</button>
                        </div>
                    </form>
                </div>
                <div id="loading-area" className="divHide loading"></div> 
            </div>
        )
    }
}

export default BudgetProjectForm;